module.exports = __webpack_public_path__ + "static/20-12ff9a1d219dd725b406017a0b837539.png";